import Hero from "./components/Hero";

function App() {
  return (
    <div>
      <Hero />
    </div>
  );
}

export default App;
